module.exports = __webpack_public_path__ + "static/media/NEW2.e95f9d0a.png";